import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// GridContainer only supports row wrapping flex-wrap: no wrap will have unintended consequences
const ColumnGridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Item = styled.div`
  display: flex;
  flex: 0 0 ${props => props.itemPercent}%;
  padding-right: ${props => props.gutter};
  padding-bottom: ${props => props.gutter};
  -ms-flex-preferred-size: calc(${props => props.itemPercent}% - ${props => props.gutter});
`;

const ColumnGrid = ({
  elements, columns, gutter, ...rest
}) => {
  const itemPercent = (1 / columns) * 100;
  return (
    <ColumnGridContainer {...rest}>
      {elements.map((element, index) => (
        /* elements should contain keys if they are dynamic; fallback is index for static assets */
        <Item gutter={gutter} itemPercent={itemPercent} key={element.key || index}>{element}</Item>
      ))}
    </ColumnGridContainer>
  );
};

ColumnGrid.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.node).isRequired,
  columns: PropTypes.number.isRequired,
  gutter: PropTypes.string // "12px"
};

ColumnGrid.defaultProps = {
  gutter: '0px'
};

export default ColumnGrid;
